import React, { useEffect, useState } from 'react';
import { NAV_LINKS, OFFER_ANCHOR, PRODUCT, TICKER_ITEMS } from '../data/woodworking';

/** Slim moving ribbon + compact sticky header on the light hero background. */
export function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Four copies per half keep the loop seamless on wide screens.
  const half = [...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS];
  const track = [...half, ...half];
  return <>
      <div className="marquee overflow-hidden bg-bottle" data-id="element-110" data-mp="25tw3y6i3jd45">
        <p className="sr-only" data-id="element-111" data-mp="3lbphtoueyunw">{TICKER_ITEMS.join(' • ')}</p>
        <div className="animate-marquee flex h-[26px] w-max items-center sm:h-[30px]" aria-hidden data-id="element-112" data-mp="3la4m3vwd55og">
          {track.map((item, index) => <span key={`${item}-${index}`} className="flex shrink-0 items-center whitespace-nowrap text-[11px] font-semibold leading-none uppercase tracking-[0.16em] text-ivory" data-id="element-113" data-mp="1bw93j0n64z1q" data-mpi={index}>
              {item}
              <span className="mx-7 h-1 w-1 rounded-full bg-olive-pale sm:mx-9" data-id="element-114" data-mp="1ky063wmewprd" />
            </span>)}
        </div>
      </div>

      <header className={`sticky top-0 z-30 border-b transition-colors duration-200 ease-out ${scrolled ? 'border-pine/10 bg-linen/95 backdrop-blur' : 'border-transparent bg-linen'}`} data-id="element-115" data-mp="1ptxmu41l7y4o">
        <div className="mx-auto flex h-[60px] w-full max-w-6xl items-center justify-between gap-4 px-5 sm:h-14 sm:px-8" data-id="element-116" data-mp="126fqdv7dobvd">
          <a href="#top" className="flex min-h-[44px] min-w-0 items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-bottle" aria-label={`${PRODUCT.name} — back to top`} data-id="element-117" data-mp="16xfoh3s8gzzg">
            <span className="wordmark flex flex-col text-left text-[clamp(1.3rem,5.8vw,1.42rem)] text-pine sm:flex-row sm:gap-[0.4em] sm:text-[0.95rem]" data-id="element-118" data-mp="efaajg1ftjl2">
              <span data-id="element-119" data-mp="1ct7lzm0zvey5">Woodworking</span>
              <span className="whitespace-nowrap" data-id="element-120" data-mp="1cs66n5cy46am">
                Furniture Plans<sup className="ml-0.5 font-sans text-[0.55em] font-semibold" data-id="element-121" data-mp="1qkcb3u6qkou8">™</sup>
              </span>
            </span>
          </a>

          <nav aria-label="Sections" className="hidden items-center gap-7 lg:flex" data-id="element-122" data-mp="1mjams8ecxx71">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="whitespace-nowrap text-[0.88rem] font-medium text-moss transition-colors duration-150 ease-out hover:text-bottle focus:outline-none focus-visible:text-bottle focus-visible:underline" data-id="element-123" data-mp="yurcjnbqzacb">
                {link.label}
              </a>)}
          </nav>

          <a href={OFFER_ANCHOR} className="hidden min-h-[44px] items-center whitespace-nowrap rounded-[8px] bg-ember px-4 text-[0.8rem] font-bold uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-out hover:bg-ember-deep focus:outline-none focus-visible:ring-4 focus-visible:ring-bottle/40 sm:inline-flex" data-id="element-124" data-mp="2jauphrcwucmy">
            Get the Collection
          </a>
        </div>
      </header>
    </>;
}